export default {
  autoOpenModule(modalToOpen, currentModal) {
    const element = document.querySelector(`[js-module-url-params-openable="{target: '#${modalToOpen}'}"]`);
    let moduleToOpen = element.getAttribute('js-module-url-params-openable').match(/target:\s*['"]([^'"]+)['"]/)[1].substring(1)
    if (moduleToOpen === currentModal.el.id || moduleToOpen === 'price-configurator' && currentModal.el.id == 'comparator') {
      setTimeout(function () {
        element.dispatchEvent(new MouseEvent('click'))
      })
    }
  }
}